import { fetchProfilesOptions } from "PFCore/services/profile";
import { Profile } from "PFTypes";
import { CustomType } from "PFTypes/custom_type";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { generateQueryFunction, getValue } from "../utils/utils";

export type CustomTypesWithCategory = CustomType & {
  sections?: {
    id: number;
    key: string;
  }[];
};

interface UseFilters {
  customTypes: CustomTypesWithCategory[];
  selectedFilters: any;
  currentProfile: Profile;
  tab: string;
}

const LAST_REPORT_POSITION = 1000000;

export const useFilters = ({ customTypes, selectedFilters, currentProfile, tab }: UseFilters) => {
  const { t } = useTranslation("insights");

  const insightsMeta = useMemo(() => {
    if (!customTypes) {
      return { filters: {} };
    }

    const insightsCustomTypes = customTypes.filter((customType) =>
      customType?.sections?.find((ctSection) => ctSection.key === "filters_planner")
    );

    const insightsFilters = {};

    // @ts-ignore
    insightsFilters.strings = {
      profile_id: {
        name: "profile_id",
        title: "To track resourcer as another filter",
        type: "hidden",
        query: (data: { term?: string }) => fetchProfilesOptions(data),
        value: getValue({ name: "profile_id" }, selectedFilters)
      }
    };

    insightsCustomTypes.forEach((customType) => {
      const value = getValue(customType, selectedFilters);

      // @ts-ignore
      insightsFilters.strings[customType.name] = {
        name: `pcf_[${customType.name}]`,
        title: customType.display_as,
        type: "select_many",
        letClear: !!value,
        value,
        sections: [],
        query: generateQueryFunction(customType.name, currentProfile),
        disabled: customType.name === "talent_pool" && !(currentProfile?.talent_pool?.length > 0),
        ordinal: 1
      };
    });

    if (["bookingReports", "roles", "platform"].includes(tab)) {
      // @ts-ignore
      insightsFilters.availability = {
        name: "availability",
        title: t("selectAPeriod"),
        value: selectedFilters["availability"],
        type: "reporting_range",
        ordinal: LAST_REPORT_POSITION,
        allowFuture: tab === "bookingReports"
      };
    }

    return { filters: insightsFilters, filterTypes: insightsCustomTypes };
  }, [customTypes, selectedFilters, tab]);

  return insightsMeta;
};
